
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2mPpz", function(module, exports) {

var $byfJM = parcelRequire("byfJM");

const $479bf4f98cf9c8c7$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>(0, $byfJM.createPlacementComponent)(placementId, Component, placementConfigurationOptions);
module.exports["createPlacementComponent"] = $479bf4f98cf9c8c7$export$8a57effc6307f916;

});

parcelRegister("byfJM", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $T9xHm = parcelRequire("T9xHm");


var $1eSke = parcelRequire("1eSke");

var $4H1Ql = parcelRequire("4H1Ql");


var $kO3gu = parcelRequire("kO3gu");


var $a8wvv = parcelRequire("a8wvv");


var $9dOtv = parcelRequire("9dOtv");


var $eXPKf = parcelRequire("eXPKf");

var $MnX4h = parcelRequire("MnX4h");


var $2HRxT = parcelRequire("2HRxT");

const $573f4005c25c6dbc$var$OptionalPlacementFetchingProvider = ({ children: children, fetch: fetch })=>{
    const isPlacementFetchingOverrideEnabled = (0, $c6GJD.default).checkGate('enable-post-office-rml-fetch-provider');
    if (isPlacementFetchingOverrideEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $kO3gu.MaybePlacementFetchingProvider), {
        fetch: fetch?.fetch,
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
const $573f4005c25c6dbc$export$eaeb39efb2b24b52 = (placementId, Component, placementConfigurationOptions)=>(0, $2HRxT.withErrorBoundary)((props)=>{
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (placementConfigurationOptions?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $T9xHm.isIsolatedCloud)()) return null;
        const { context: contextWithRoute, onEvent: onEvent, initialData: initialData, fetch: fetch, ...componentProps } = props;
        const { postOfficeRoute: route, ...context } = contextWithRoute;
        if ((0, $1eSke.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        const stableContext = (0, $4H1Ql.useStableObject)(context);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTracking), {
            initialData: initialData,
            onEvent: onEvent,
            children: /*#__PURE__*/ (0, $l998X.jsx)($573f4005c25c6dbc$var$OptionalPlacementFetchingProvider, {
                fetch: fetch,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $MnX4h.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: placementConfigurationOptions?.choreographer,
                    subscription: placementConfigurationOptions?.subscription,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        context: stableContext,
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    });
const $573f4005c25c6dbc$export$8a57effc6307f916 = (placementId, Component, placementConfigurationOptions)=>{
    const placement = $573f4005c25c6dbc$export$eaeb39efb2b24b52(placementId, Component, placementConfigurationOptions);
    return (props)=>{
        const { onError: onError, fallbackRender: fallbackRender } = (0, $9dOtv.useComponentErrorHandling)(props);
        return placement({
            ...props,
            errorBoundaryLocation: (0, $a8wvv.ERROR_BOUNDARY_LOCATION),
            placementId: placementId,
            onError: onError,
            fallbackRender: fallbackRender
        });
    };
};
module.exports["createPlacementComponent"] = $573f4005c25c6dbc$export$8a57effc6307f916;

});

parcelRegister("9dOtv", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94fea169e2cb8de7$export$3d127465d22fe4e5 = ({ onEvent: onEvent, onError: onError, fallbackRender: fallbackRender, errorFallback: errorFallback })=>{
    const internalOnError = (0, $42omo.useCallback)((error, info)=>{
        onEvent?.({
            type: 'component-error',
            error: error
        });
        onError?.(error, info);
    }, [
        onEvent,
        onError
    ]);
    // This is here to facade for a extra prop that overwrote the original error boundary api, consituting a breaking change.
    // This makes sure that the original api is still valid.
    const internalFallbackRender = fallbackRender ?? errorFallback;
    return {
        onError: internalOnError,
        fallbackRender: internalFallbackRender
    };
};
module.exports["useComponentErrorHandling"] = $94fea169e2cb8de7$export$3d127465d22fe4e5;

});

parcelRegister("cyz5M", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 
var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");

var $h6POP = parcelRequire("h6POP");


var $hOVIX = parcelRequire("hOVIX");


var $3Shv6 = parcelRequire("3Shv6");


var $aEUWC = parcelRequire("aEUWC");


var $jVzfH = parcelRequire("jVzfH");


var $2amyA = parcelRequire("2amyA");


var $Sjnjb = parcelRequire("Sjnjb");


var $cqOSB = parcelRequire("cqOSB");


var $9iUWG = parcelRequire("9iUWG");


var $fUB5z = parcelRequire("fUB5z");


var $2HRxT = parcelRequire("2HRxT");


var $hyvHs = parcelRequire("hyvHs");


var $42omo = parcelRequire("42omo");


var $lVEBn = parcelRequire("lVEBn");

const $765afc5340447923$var$STABLE_EMPTY_OBJECT = {};
const $765afc5340447923$export$9750eb54d7c7e789 = ({ children: children, ...props })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $42omo.Suspense), {
        ...props,
        children: children
    });
};
const $765afc5340447923$export$7b7e5a348ef9a7c1 = (messageComponents, messageValidator)=>{
    const initializeMessageRenderer = ()=>{
        // Return renderer component
        return /*#__PURE__*/ (0, $42omo.memo)(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, recommendationSession: recommendationSession, fallbackRender: fallbackRender, loadingFallback: loadingFallback, onError: onError, messageCategory: messageCategory, postOffice: postOffice, triggerId: triggerId, messageCreationType: messageCreationType, journeyId: journeyId, journeyTriggerId: journeyTriggerId, SuspenseBoundary: SuspenseBoundary = (0, $42omo.Suspense), ...data })=>{
            const isUFOEnabled = (0, $c6GJD.default).checkGate('enable_ufo_tracking_in_post_office');
            const isMessageRendererProviderEnabled = (0, $c6GJD.default).checkGate('po-refactor-message-renderer-provider');
            const isTriggerChoreographingEnabled = (0, $c6GJD.default).checkGate('post-office_enable_trigger-choreographing');
            const recommendationSessionStable = (0, $4H1Ql.useStableObject)(recommendationSession ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const postOfficeStable = (0, $4H1Ql.useStableObject)(postOffice ?? $765afc5340447923$var$STABLE_EMPTY_OBJECT);
            const { markMessageFailed: markMessageFailed, markMessageUnmounted: markMessageUnmounted, messageSuccessComponent: messageSuccessComponent } = (0, $42omo.useMemo)(()=>{
                const messagePerformanceTracker = isUFOEnabled ? new (0, $3NyPa.UFOv1).MessagePerformanceTracker(messageTemplateId) : undefined;
                const onMessageSuccess = ()=>{
                    messagePerformanceTracker?.markSuccess();
                };
                const markMessageFailed = (onError)=>(error, info)=>{
                        messagePerformanceTracker?.markFailure(error);
                        onError && onError(error, info);
                    };
                return {
                    /** To be called when the message is unmounted  */ markMessageUnmounted: messagePerformanceTracker?.abort,
                    /** To be called when the message fails to render */ markMessageFailed: markMessageFailed,
                    /** To be rendered when the message is successfully loaded */ messageSuccessComponent: /*#__PURE__*/ (0, $l998X.jsx)((0, $fUB5z.TrackMount), {
                        onMount: onMessageSuccess
                    })
                };
            }, [
                messageTemplateId
            ]);
            (0, $42omo.useEffect)(()=>{
                return ()=>{
                    markMessageUnmounted?.();
                };
            }, [
                markMessageUnmounted
            ]);
            const Core = ()=>{
                const Component = messageComponents?.[messageTemplateId];
                // This should not happen but things can happen at runtime;
                if (!Component) // Throw to error boundary
                throw new (0, $hOVIX.InvalidMessageTemplateIdError)(JSON.stringify({
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId
                }));
                let validatedMessage;
                if (messageValidator) {
                    // The messageValidator should also throw an error if the validation failed,
                    // which will again be thrown here and should be caught by the ErrorBoundary
                    validatedMessage = messageValidator(data);
                    if (!validatedMessage) throw new (0, $hOVIX.MessageRendererEmptyValidationResponseError)();
                }
                const loadingComponent = (0, $42omo.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $l998X.jsx)((0, $h6POP.UFOv2).UFOLoadHold, {
                        name: (0, $h6POP.UFOv2).HoldNames.MESSAGE,
                        children: loadingFallback ?? null
                    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
                        children: loadingFallback ?? null
                    }), // oxlint-disable-next-line react-hooks/exhaustive-deps
                [
                    loadingFallback,
                    isUFOEnabled
                ]);
                // This any should be factored out as part of validation work
                const componentProps = messageValidator ? validatedMessage : data;
                const componentPropsStable = (0, $4H1Ql.useStableObject)(componentProps);
                // Client-triggered messages: hydrate must return triggerType at top level
                // (e.g. triggerType: messageContext.triggerType). Single source of truth.
                const triggerType = componentProps.triggerType;
                const hasTrigger = isTriggerChoreographingEnabled && (0, $9iUWG.isClientTriggeredMessage)(triggerType);
                if (isTriggerChoreographingEnabled) // eslint-disable-next-line no-console -- Temporary debug logging for trigger choreography
                console.info('hasTrigger', {
                    messageTemplateId: messageTemplateId,
                    messageInstanceId: messageInstanceId,
                    triggerType: triggerType
                });
                // messageTemplateId exists in the API but component is empty (should not happen)
                if (!Component) return null;
                // Create waitForTrigger for triggered messages
                const { waitForTrigger: waitForTrigger } = (0, $cqOSB.useWaitForTrigger)(hasTrigger, messageSuccessComponent);
                if (isMessageRendererProviderEnabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $jVzfH.MessageRendererProvider), {
                    messageInstanceId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    recommendationSession: recommendationSessionStable === $765afc5340447923$var$STABLE_EMPTY_OBJECT ? undefined : recommendationSessionStable,
                    messageSuccessComponent: messageSuccessComponent,
                    componentProps: componentPropsStable,
                    loadingFallback: loadingFallback,
                    triggerId: triggerId,
                    messageCreationType: messageCreationType,
                    postOffice: postOfficeStable,
                    isUFOEnabled: isUFOEnabled,
                    SuspenseBoundary: SuspenseBoundary,
                    waitForTrigger: waitForTrigger,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                        onError: onError,
                        ...componentProps,
                        waitForTrigger: waitForTrigger
                    })
                });
                // Legacy path (when MessageRendererProvider is disabled)
                const messageContent = /*#__PURE__*/ (0, $l998X.jsx)((0, $2amyA.FeatureFlaggedUfoWrapper), {
                    messageTemplateId: messageTemplateId,
                    isEnabled: isUFOEnabled,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $3Shv6.MessageContextProvider), {
                        value: {
                            messageInstanceId: messageInstanceId,
                            messageTemplateId: messageTemplateId,
                            triggerId: triggerId,
                            messageCreationType: messageCreationType,
                            transactionAccountId: componentProps.transactionAccountId,
                            analyticsDetails: postOffice?.analyticsDetails,
                            journeyId: journeyId,
                            journeyTriggerId: journeyTriggerId
                        },
                        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $hyvHs.RecommendationProvider), {
                            value: recommendationSession ?? {},
                            children: /*#__PURE__*/ (0, $l998X.jsx)(SuspenseBoundary, {
                                fallback: loadingComponent,
                                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aEUWC.MessageAnalyticsContextProvider), {
                                    children: [
                                        !waitForTrigger && messageSuccessComponent,
                                        /*#__PURE__*/ (0, $l998X.jsx)(Component, {
                                            onError: onError,
                                            messageInstanceId: messageInstanceId,
                                            ...componentProps,
                                            waitForTrigger: waitForTrigger
                                        })
                                    ]
                                })
                            })
                        })
                    })
                });
                // Triggered messages handle choreography with TriggeredMessageValidator
                if (waitForTrigger) return /*#__PURE__*/ (0, $l998X.jsx)((0, $Sjnjb.TriggeredMessageValidator), {
                    waitForTrigger: waitForTrigger,
                    children: messageContent
                });
                // Regular messages use automatic choreography
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $lVEBn.ChoreographerWrapper), {
                    messageId: messageInstanceId,
                    messageTemplateId: messageTemplateId,
                    messageCategory: messageCategory,
                    children: messageContent
                });
            };
            return (0, $2HRxT.withErrorBoundary)(Core)({
                errorBoundaryLocation: 'placement-message-renderer-component',
                messageTemplateId: messageTemplateId,
                fallbackRender: fallbackRender,
                onError: markMessageFailed(onError)
            });
        });
    };
    return {
        initializeMessageRenderer: initializeMessageRenderer,
        MessageRenderer: initializeMessageRenderer()
    };
};
module.exports["MaybeSuspenseBoundary"] = $765afc5340447923$export$9750eb54d7c7e789;
module.exports["asMessageRenderer"] = $765afc5340447923$export$7b7e5a348ef9a7c1;

});

parcelRegister("3NyPa", function(module, exports) {

var $jTlSd = parcelRequire("jTlSd");


var $koKWt = parcelRequire("koKWt");

const $959aa8656bf0972c$export$96236906ebaa7f87 = {
    MessagePerformanceTracker: $jTlSd.MessagePerformanceTracker,
    PlacementPerformanceTracker: $koKWt.PlacementPerformanceTracker
};
module.exports["UFOv1"] = $959aa8656bf0972c$export$96236906ebaa7f87;

});

parcelRegister("jTlSd", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

class $71d7f78b2ff13923$export$ae5c73c7c4f454e6 {
    constructor(messageTemplateId){
        this.aggregatedExperience = void 0;
        this.messageSpecificExperience = void 0;
        this.experiences = void 0;
        this.metadata = {};
        this.markSuccess = ()=>{
            for (const experience of this.experiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFailure = (error)=>{
            for (const experience of this.experiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    error: JSON.stringify(error)
                }
            });
        };
        this.abort = ()=>{
            for (const experience of this.experiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).MESSAGE, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.messageSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).MESSAGE}.${messageTemplateId}`, {
            performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
            type: (0, $9NDUe.ExperienceTypes).Load,
            platform: {
                component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
            }
        });
        this.experiences = [
            this.aggregatedExperience,
            this.messageSpecificExperience
        ];
        this.experiences.forEach((experience)=>experience.start());
        this.metadata = {
            messageTemplateId: messageTemplateId
        };
    }
}
module.exports["MessagePerformanceTracker"] = $71d7f78b2ff13923$export$ae5c73c7c4f454e6;

});

parcelRegister("haNjI", function(module, exports) {
const $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1 = {
    REMOTE_PLACEMENT: 'post-office-remote-loaded-placement',
    PLACEMENT: 'post-office-placement',
    MESSAGE: 'post-office-message'
};
const $ac68ec5e99dfa5a8$export$6d482cfa20c9d220 = 'post-office';
module.exports["UFOExperienceNames"] = $ac68ec5e99dfa5a8$export$cc7ddf8ca628f6f1;
module.exports["POST_OFFICE_PLATFORM_NAME"] = $ac68ec5e99dfa5a8$export$6d482cfa20c9d220;

});

parcelRegister("koKWt", function(module, exports) {

var $9NDUe = parcelRequire("9NDUe");

var $5aVN7 = parcelRequire("5aVN7");


var $haNjI = parcelRequire("haNjI");

const $f3e04d171a04c0ba$var$STEPS = {
    RML_FETCH: 'rml-fetch',
    RML_RENDER: 'rml-render',
    INITIAL_DATA: 'initial-data-load',
    COMPONENT_READY: 'component-ready'
};
const $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG = {
    performanceType: (0, $9NDUe.ExperiencePerformanceTypes).PageSegmentLoad,
    type: (0, $9NDUe.ExperienceTypes).Load,
    platform: {
        component: (0, $haNjI.POST_OFFICE_PLATFORM_NAME)
    },
    timings: [
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`
        },
        {
            key: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`,
            endMark: `${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`
        }
    ]
};
class $f3e04d171a04c0ba$export$8b48c2105ba0b35a {
    constructor(placementId, consumptionType = 'remote'){
        /** UFO experience for tracking the performance of all placements in aggregate.
     * This supports setting up a single platform-level SLO for all placements.
     */ this.aggregatedExperience = void 0;
        /** UFO experience for tracking the performance of a specific placement.
     * This supports setting up a placement-specific SLOs.
     */ this.placementSpecificExperience = void 0;
        this.placementExperiences = [];
        this.metadata = {};
        this.markFetchComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_FETCH}-complete`);
        };
        this.markRenderComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.RML_RENDER}-complete`);
        };
        this.markInitialDataComplete = ()=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-complete`);
        };
        this.markComponentReady = ()=>{
            for (const experience of this.placementExperiences)experience.success({
                metadata: this.metadata
            });
        };
        this.markFetchFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_FETCH,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markRenderFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.RML_RENDER,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markInitialDataFailure = (_)=>{
            for (const experience of this.placementExperiences)experience.mark(`${$f3e04d171a04c0ba$var$STEPS.INITIAL_DATA}-error`);
        };
        this.markComponentFailure = (error)=>{
            for (const experience of this.placementExperiences)experience.failure({
                metadata: {
                    ...this.metadata,
                    failedDuring: $f3e04d171a04c0ba$var$STEPS.COMPONENT_READY,
                    error: JSON.stringify(error)
                }
            });
        };
        this.markComponentAborted = ()=>{
            for (const experience of this.placementExperiences)experience.abort({
                metadata: this.metadata
            });
        };
        this.aggregatedExperience = new (0, $5aVN7.UFOExperience)((0, $haNjI.UFOExperienceNames).PLACEMENT, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementSpecificExperience = new (0, $5aVN7.UFOExperience)(`${(0, $haNjI.UFOExperienceNames).PLACEMENT}.${placementId}`, $f3e04d171a04c0ba$var$UFO_EXPERIENCE_CONFIG);
        this.placementExperiences = [
            this.aggregatedExperience,
            this.placementSpecificExperience
        ];
        for (const experience of this.placementExperiences)experience.start();
        this.metadata = {
            placementId: placementId,
            consumptionType: consumptionType
        };
    }
}
module.exports["PlacementPerformanceTracker"] = $f3e04d171a04c0ba$export$8b48c2105ba0b35a;

});

parcelRegister("lVEBn", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $c6GJD = parcelRequire("c6GJD");


var $7XIdu = parcelRequire("7XIdu");


var $3zCGc = parcelRequire("3zCGc");


var $42omo = parcelRequire("42omo");

const $5d2b57d7f45b3b6a$var$ChoreographedComponent = ({ children: children, messageId: messageId, choreographerFactory: choreographerFactory })=>{
    const { useChoreographedRender: useChoreographedRender } = choreographerFactory;
    const shouldRender = useChoreographedRender({
        messageId: messageId
    });
    if (shouldRender) return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
    return null;
};
const $5d2b57d7f45b3b6a$export$8db7ba034addcd65 = ({ children: children, messageId: messageId, messageTemplateId: messageTemplateId, messageCategory: messageCategory })=>{
    const { factory: factory, choreographerEnabled: choreographerEnabled } = (0, $3zCGc.useChoreographerContext)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $7XIdu.useFirePostOfficeAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        const isTrackingChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_tracking_choreographed_post_office_messages');
        if (isTrackingChoreographedPostOfficeMessagesEnabled) fireAnalyticsEvent({
            eventType: 'operational',
            action: 'maybeChoreographed',
            actionSubject: 'postOfficeMessage'
        }, {
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
    }, [
        fireAnalyticsEvent
    ]);
    const isChoreographedPostOfficeMessagesEnabled = (0, $c6GJD.default).checkGate('enable_choreographed_post_office_messages');
    const useMessageTemplateIdAsChoreographerMessageId = (0, $c6GJD.default).checkGate('post-office_use_template_id_for_choreo');
    if (choreographerEnabled && isChoreographedPostOfficeMessagesEnabled) {
        if (!factory) return null;
        const { shouldBeChoreographed: shouldBeChoreographed } = factory;
        const messageType = messageCategory ? messageCategory.toLowerCase() : undefined;
        if (shouldBeChoreographed({
            messageType: messageType
        })) {
            // Use messageTemplateId as choreographer messageId when feature flag is enabled,
            // otherwise use the original messageId (messageInstanceId) for backward compatibility
            const choreographerMessageId = useMessageTemplateIdAsChoreographerMessageId ? messageTemplateId : messageId;
            return /*#__PURE__*/ (0, $l998X.jsx)($5d2b57d7f45b3b6a$var$ChoreographedComponent, {
                choreographerFactory: factory,
                messageId: choreographerMessageId,
                children: children
            });
        }
    }
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
module.exports["ChoreographerWrapper"] = $5d2b57d7f45b3b6a$export$8db7ba034addcd65;

});

parcelRegister("6Ht9d", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $gAOec = parcelRequire("gAOec");

const $876859b1b10b173e$export$5523c5f3222291d0 = (initialData)=>{
    const initialDataCallback = (0, $42omo.useMemo)(()=>{
        if (typeof initialData === 'undefined') return undefined;
        return ()=>initialData;
    }, [
        initialData
    ]);
    return (0, $gAOec.useData)(initialDataCallback, {
        analytics: {
            name: 'initialData'
        }
    });
};
module.exports["useInitialData"] = $876859b1b10b173e$export$5523c5f3222291d0;

});

parcelRegister("9QvUi", function(module, exports) {
$parcel$export(module.exports, "default", () => $13bb23ac78effffb$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $4H1Ql = parcelRequire("4H1Ql");


var $NT2w1 = parcelRequire("NT2w1");


var $2mPpz = parcelRequire("2mPpz");


var $eXPKf = parcelRequire("eXPKf");


var $42omo = parcelRequire("42omo");


var $2xYsH = parcelRequire("2xYsH");


var $hnA4H = parcelRequire("hnA4H");

const $13bb23ac78effffb$var$STABLE_OBJECT = {};
const $13bb23ac78effffb$var$Placement = ({ placementId: placementId, placementProps: placementProps, children: children, ErrorFallback: ErrorFallback, PlacementComponent: PlacementComponent, disableInitialData: disableInitialData = false, onEvent: onEvent })=>{
    const MemoizedPlacement = (0, $42omo.useMemo)(()=>(0, $2mPpz.createPlacementComponent)(placementId, PlacementComponent), [
        placementId,
        PlacementComponent
    ]);
    const stableLocalPlacementProps = (0, $4H1Ql.useStableObject)(placementProps ?? $13bb23ac78effffb$var$STABLE_OBJECT);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eXPKf.PerformanceTrackingSegment), {
        placementId: placementId,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $NT2w1.default), {
            placementId: placementId,
            consumptionType: "local",
            onEvent: onEvent,
            disableInitialData: disableInitialData,
            children: ({ initialData: initialData, context: context, onEvent: sharedOnEvent })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $2xYsH.default), {
                    analyticsChannel: (0, $hnA4H.ANALYTICS_CHANNEL),
                    placementId: placementId,
                    onError: sharedOnEvent,
                    fallback: ErrorFallback,
                    children: /*#__PURE__*/ (0, $l998X.jsx)(MemoizedPlacement, {
                        initialData: initialData,
                        context: context,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore - Confluence Local Consumption
                        errorFallback: ErrorFallback,
                        onEvent: sharedOnEvent,
                        ...stableLocalPlacementProps,
                        children: children
                    })
                })
        })
    });
};
var $13bb23ac78effffb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $42omo.memo)($13bb23ac78effffb$var$Placement);

});

parcelRegister("NT2w1", function(module, exports) {

var $ffCOo = parcelRequire("ffCOo");


var $PAiZW = parcelRequire("PAiZW");

var $6yHRM = parcelRequire("6yHRM");

var $4H1Ql = parcelRequire("4H1Ql");


var $3NyPa = parcelRequire("3NyPa");


var $kO3gu = parcelRequire("kO3gu");


var $42omo = parcelRequire("42omo");


var $4u5NT = parcelRequire("4u5NT");


var $dE7qQ = parcelRequire("dE7qQ");


var $5dPMD = parcelRequire("5dPMD");


var $dug7n = parcelRequire("dug7n");


var $feexy = parcelRequire("feexy");


var $9x4nt = parcelRequire("9x4nt");


var $dh538 = parcelRequire("dh538");

const $80ab3a0c2f45d583$var$useInitialDataIfEnabled = (placementId, context, baseUrl, path, disableInitialData)=>{
    const fetcher = (0, $kO3gu.usePlacementFetchingContext)();
    return (0, $42omo.useMemo)(()=>disableInitialData ? undefined : (0, $5dPMD.requestInitialData)(placementId, context, fetcher.fetch, {
            baseUrl: baseUrl,
            path: path
        }), [
        disableInitialData,
        baseUrl,
        path,
        placementId,
        context,
        fetcher.fetch
    ]);
};
/**
 * Validates error is a standard Error instance. If not, wraps in new Error instance.
 */ const $80ab3a0c2f45d583$var$validateErrorFromEventType = (err, eventType)=>{
    if (err instanceof Error) return err;
    if (typeof err === 'string') return new Error(err);
    return new Error(`Unknown error during ${eventType}`);
};
/**
 * Reports an error to UFO v2 for a given placement, on the current UFO v2 active interaction.
 * @param ufoV2Interaction Context of the current active UFO v2 interaction
 * @param placementId Post Office placement identifier
 * @param error
 * @param errorEventType Event type that triggered the error
 * @returns void
 */ const $80ab3a0c2f45d583$var$handleUfoV2Error = ({ ufoV2Interaction: ufoV2Interaction, placementId: placementId, error: error, errorEventType: errorEventType })=>{
    const validatedError = $80ab3a0c2f45d583$var$validateErrorFromEventType(error, errorEventType);
    const { interactionId: interactionId, labelStack: labelStack } = ufoV2Interaction;
    if (interactionId) (0, $4u5NT.addError)(interactionId, `${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
    else (0, $4u5NT.addErrorToAll)(`${errorEventType}:${placementId}`, labelStack || null, validatedError.name, validatedError.message, validatedError.stack);
};
const $80ab3a0c2f45d583$var$Placement = ({ placementId: placementId, consumptionType: consumptionType, onEvent: placementOnEvent, disableInitialData: disableInitialData = false, children: children })=>{
    const isUFOEnabled = true;
    const postOfficeRoute = (0, $6yHRM.usePostOfficeRoute)();
    const context = (0, $PAiZW.usePostOfficeContext)();
    const { baseUrl: baseUrl, path: path } = (0, $dug7n.useBuildBasePath)();
    const stableContextWithRoute = (0, $4H1Ql.useStableObject)({
        ...context,
        postOfficeRoute: postOfficeRoute
    });
    const ufoV1PlacementTracker = (0, $42omo.useMemo)(()=>isUFOEnabled ? new (0, $3NyPa.UFOv1).PlacementPerformanceTracker(placementId, consumptionType) : undefined, [
        isUFOEnabled,
        placementId,
        consumptionType
    ]);
    const ufoV2InteractionId = (0, $42omo.useContext)((0, $feexy.default));
    const ufoV2InteractionContext = (0, $42omo.useContext)((0, $9x4nt.default));
    const stableUfoV2Interaction = (0, $4H1Ql.useStableObject)({
        interactionId: ufoV2InteractionId.current,
        labelStack: ufoV2InteractionContext?.labelStack
    });
    // Callback function to listen to the different stages of the component and track its performance
    const componentOnEvent = (0, $42omo.useCallback)(({ type: type, error: error })=>{
        // Used for local placement components, UFO v2 events
        if (consumptionType === 'local') {
            switch(type){
                case 'fetch-error':
                case 'component-error':
                case 'render-error':
                    if ((0, $dh538.fg)('post-office_enable_ufo-v2-add-error')) $80ab3a0c2f45d583$var$handleUfoV2Error({
                        ufoV2Interaction: stableUfoV2Interaction,
                        placementId: placementId,
                        error: error,
                        errorEventType: type
                    });
            }
            return;
        }
        // Used for remote placement components, UFO v1 events
        if (consumptionType === 'remote') {
            placementOnEvent?.({
                type: type,
                error: error
            });
            switch(type){
                case 'fetch-complete':
                    ufoV1PlacementTracker?.markFetchComplete();
                    break;
                case 'fetch-error':
                    ufoV1PlacementTracker?.markFetchFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'render-complete':
                    ufoV1PlacementTracker?.markRenderComplete();
                    break;
                case 'render-error':
                    ufoV1PlacementTracker?.markRenderFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'initial-data-complete':
                    ufoV1PlacementTracker?.markInitialDataComplete();
                    break;
                case 'initial-data-error':
                    ufoV1PlacementTracker?.markInitialDataFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-error':
                    ufoV1PlacementTracker?.markComponentFailure($80ab3a0c2f45d583$var$validateErrorFromEventType(error, type));
                    break;
                case 'component-ready':
                    ufoV1PlacementTracker?.markComponentReady();
                    break;
                case 'unmount':
                    ufoV1PlacementTracker?.markComponentAborted();
                    break;
            }
        }
    }, [
        placementOnEvent,
        ufoV1PlacementTracker,
        consumptionType,
        placementId,
        stableUfoV2Interaction
    ]);
    const initialData = $80ab3a0c2f45d583$var$useInitialDataIfEnabled(placementId, context, baseUrl, path, disableInitialData);
    const placementAnalyticsContext = (0, $42omo.useMemo)(()=>({
            source: (0, $dE7qQ.ANALYTICS_SOURCE),
            componentName: `Placement`,
            attributes: {
                placementId: placementId,
                channel: 'in-app'
            }
        }), [
        placementId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ffCOo.PostOfficeAnalyticsContext), {
        data: placementAnalyticsContext
    }, children({
        initialData: initialData,
        context: stableContextWithRoute,
        onEvent: componentOnEvent
    }));
};
var $80ab3a0c2f45d583$export$2e2bcd8739ae039 = $80ab3a0c2f45d583$var$Placement;
module.exports["default"] = $80ab3a0c2f45d583$export$2e2bcd8739ae039;

});

parcelRegister("dE7qQ", function(module, exports) {
const $2d2adb07a8ea6d4a$export$85183a312807388d = 'postOffice';
const $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6 = 'post-office-frontend';
module.exports["ANALYTICS_SOURCE"] = $2d2adb07a8ea6d4a$export$f7109619a5e9e0d6;

});

parcelRegister("dug7n", function(module, exports) {

var $bnKhH = parcelRequire("bnKhH");

var $c3xd8 = parcelRequire("c3xd8");


var $42omo = parcelRequire("42omo");

const $f2f503b4228c54ff$export$83d6c58b7ab7ae67 = ()=>{
    const postOfficeEnvironment = (0, $c3xd8.usePostOfficeEnvironment)();
    return (0, $42omo.useMemo)(()=>(0, $bnKhH.buildBasePath)(postOfficeEnvironment.currentEnv, postOfficeEnvironment.envConfigs), [
        postOfficeEnvironment.currentEnv,
        postOfficeEnvironment.envConfigs
    ]);
};
module.exports["useBuildBasePath"] = $f2f503b4228c54ff$export$83d6c58b7ab7ae67;

});

parcelRegister("2xYsH", function(module, exports) {
$parcel$export(module.exports, "default", () => $1916333c8b5a116e$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $1DWH0 = parcelRequire("1DWH0");


var $42omo = parcelRequire("42omo");

class $1916333c8b5a116e$var$ErrorBoundary extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Component {
    componentDidCatch(error, errorInfo) {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'handled',
            actionSubject: 'error',
            actionSubjectId: 'postOfficePlacementErrorBoundary',
            attributes: {
                error: error?.message,
                errorInfo: errorInfo,
                placementId: this.props.placementId
            }
        });
        analyticsEvent.fire(this.props.analyticsChannel);
        this.props.onError({
            error: error,
            type: 'render-error'
        });
        this.setState({
            hasError: true
        });
    }
    render() {
        if (this.state.hasError) return this.props.fallback ? /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
            children: this.props.fallback
        }) : null;
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
}
var $1916333c8b5a116e$export$2e2bcd8739ae039 = (0, $1DWH0.default)()($1916333c8b5a116e$var$ErrorBoundary);

});

parcelRegister("hnA4H", function(module, exports) {
const $f3b0e253e752d4df$export$85183a312807388d = 'postOffice';
module.exports["ANALYTICS_CHANNEL"] = $f3b0e253e752d4df$export$85183a312807388d;

});


//# sourceMappingURL=post-office-placement-remote.a3849478.js.map
